import { Syntax, VariableToken } from '@trlogic/ui-pack';
import VariablePropertiesJsonSerializer from './VariablePropertiesJsonSerializer';

class ExpressionSerializer {
  private readonly serializer: VariablePropertiesJsonSerializer;

  constructor(serializer: VariablePropertiesJsonSerializer) {
    this.serializer = serializer;
  }

  public serialize = async (syntax: Syntax) => {
    const iterate = async (syntax: Syntax | undefined) => {
      if (syntax == undefined) return;
      switch (syntax.value.type) {
        case 'Common Variable':
          (syntax.value as VariableToken).properties = await this.serializer.serialize((syntax.value as VariableToken).properties);
          break;
      }
      if (syntax.children == undefined) return;
      for (const c of syntax.children) {
        await iterate(c);
      }
    };
    await iterate(syntax);
    return syntax;
  };

  public deserialize = async (syntax: Syntax) => {
    const iterate = async (syntax: Syntax | undefined) => {
      if (syntax == undefined) return;
      switch (syntax.value.type) {
        case 'Common Variable':
          (syntax.value as VariableToken).properties = await this.serializer.deserialize((syntax.value as VariableToken).properties);
          break;
      }
      if (syntax.children == undefined) return;
      for (const c of syntax.children) {
        await iterate(c);
      }
    };
    await iterate(syntax);
    return syntax;
  };
}

export default ExpressionSerializer;
